import script from "./user.vue?vue&type=script&setup=true&lang=js"
export * from "./user.vue?vue&type=script&setup=true&lang=js"

import "./user.vue?vue&type=style&index=0&id=2c760f1e&scoped=true&lang=css"

import exportComponent from "D:\\project\\97job-wechat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c760f1e"]])

export default __exports__